import * as React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
// import { useRouter } from "next/router";

import { ExpandMore } from "@mui/icons-material";

const FilterSection: React.FC<{ title: string; child: React.ReactNode }> = ({
  title,
  child,
}) => {
  return (
    <Accordion
      variant="outlined"
      disableGutters
      defaultExpanded
      className="XCategoryFilter_FilterSection"
    >
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ fontSize: "18px", color: "inherit" }} />}
      >
        <Typography className="XCategoryFilter_FilterSection_Title">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{child}</AccordionDetails>
    </Accordion>
  );
};

export default FilterSection;
